module.exports = __webpack_public_path__ + "static/img/Gallery03.d23c676.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls46-1/Gallery03.jpg
// module id = jW59
// module chunks = 12